import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "startDate", "endDate", "diff" ]
  static values = {
    originalStart: String,
    originalEnd: String,
    noChangeText: String,
    addedOneText: String,
    addedOtherText: String,
    removedOneText: String,
    removedOtherText: String
  }

  connect() {
    this.updateMinEndDate()
    this.updateDiff()
  }

  updateDiff() {
    this.updateMinEndDate()

    if (!this.hasDiffTarget) return

    const originalCount = this.monthCount(this.originalStartValue, this.originalEndValue)
    const newCount = this.monthCount(this.startDateTarget.value, this.endDateTarget.value)
    const diff = newCount - originalCount

    if (diff === 0) {
      this.diffTarget.textContent = this.noChangeTextValue
    } else if (diff > 0) {
      this.diffTarget.textContent = diff === 1
        ? this.addedOneTextValue
        : this.addedOtherTextValue.replace("__COUNT__", diff)
    } else {
      const absDiff = Math.abs(diff)
      this.diffTarget.textContent = absDiff === 1
        ? this.removedOneTextValue
        : this.removedOtherTextValue.replace("__COUNT__", absDiff)
    }
  }

  updateMinEndDate() {
    if (this.hasStartDateTarget && this.hasEndDateTarget) {
      if (this.startDateTarget.value) {
        this.endDateTarget.min = this.startDateTarget.value
        if (this.endDateTarget.value && this.endDateTarget.value < this.startDateTarget.value) {
          this.endDateTarget.value = this.startDateTarget.value
        }
      }
    }
  }

  applyRecommendation(event) {
    const btn = event.currentTarget
    const start = btn.dataset.recommendedStart
    const end   = btn.dataset.recommendedEnd

    if (this.hasStartDateTarget && start) {
      this.startDateTarget.value = start
      this.startDateTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    if (this.hasEndDateTarget && end) {
      this.endDateTarget.value = end
      this.endDateTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }

  monthCount(start, end) {
    if (!start || !end) return 0

    const startDate = new Date(`${start}T00:00:00`)
    const endDate = new Date(`${end}T00:00:00`)

    if (endDate < startDate) return 0

    return (endDate.getFullYear() - startDate.getFullYear()) * 12
      + (endDate.getMonth() - startDate.getMonth()) + 1
  }
}
